import { render, staticRenderFns } from "./add-rg-organization.vue?vue&type=template&id=1413bda8&"
import script from "./add-rg-organization.vue?vue&type=script&lang=ts&"
export * from "./add-rg-organization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports